"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalRsdkTableHeaderStyles = exports.getGlobalRsdkTableBodyStyles = exports.getRsdkTableScaleColorStyles = exports.getRsdkTableBodyStyles = exports.getRsdkTableHeaderStyles = exports.getRsdkChartStyles = void 0;
var lodash_1 = __importDefault(require("lodash"));
var RSDK_HEATMAP_CLASSES = {
    selector: '.employeeinsights-rsdkprheatmap',
    header: ['rotated-header-cell'],
    body: ['label-div', 'label-cell', 'response-cell']
};
var RSDK_QUESTION_LIST_CLASSES = {
    selector: '.employeeinsights-rsdkprquestionlist',
    header: ['question-table-header-cell'],
    body: ['question-table-body-cell'],
    shouldApplyScaleColors: true
};
var RSDK_SCORECARD_CLASSES = {
    selector: '.employeeinsights-rsdkprscorecard',
    header: ['question-table-header-cell'],
    body: ['question-table-body-cell'],
    shouldApplyScaleColors: true
};
var RSDK_ENGAGEMENT_SUMMARY_CLASSES = {
    selector: '.employeeinsights-rsdkprengagementsummary',
    header: [],
    body: [],
    shouldApplyScaleColors: true
};
var RSDK_PARTICIPATION_SUMMARY_CLASSES = {
    selector: '.employeeinsights-rsdkprparticipationsummary',
    header: [],
    body: [],
    shouldApplyScaleColors: true
};
var RSDK_CHARTS_CSS_CLASSES = [];
var RSDK_TABLES_CSS_CLASSES = [
    RSDK_HEATMAP_CLASSES,
    RSDK_QUESTION_LIST_CLASSES,
    RSDK_SCORECARD_CLASSES,
    RSDK_ENGAGEMENT_SUMMARY_CLASSES,
    RSDK_PARTICIPATION_SUMMARY_CLASSES
];
var IMPORTANT = '!important';
/**
 * Returns a CSS selector that selects all elements that contain 'className'.
 * @param {*} className partial react styles.
 */
var getPartialClassNameSelector = function (className) {
    return "[class*=" + className + "]";
};
/**
 * Gets custom chart styles for RSDK chart widgets.
 * NOTE: number widget does not use custom font size.
 */
var getRsdkChartStyles = function (formatHelper, formatObj) {
    var styles = '';
    var TEXT_SELECTOR = 'text';
    var format = formatHelper.getStyles({
        FONT: formatObj.FONT,
        COLOR: formatObj.COLOR + IMPORTANT,
        FILL: formatObj.COLOR + IMPORTANT
    }, true);
    lodash_1.default.forEach(RSDK_CHARTS_CSS_CLASSES, function (chart) {
        var css = chart + " " + TEXT_SELECTOR + " {"
            + format
            + '}';
        styles += css;
    });
    return styles;
};
exports.getRsdkChartStyles = getRsdkChartStyles;
/**
 * Gets custom table header styles for RSDK table widgets using an array of selectors.
 */
var getRsdkTableHeaderStyles = function (formatHelper, formatObj) {
    var styles = '';
    lodash_1.default.forEach(RSDK_TABLES_CSS_CLASSES, function (table) {
        var selector = table.selector;
        var format = formatHelper.getStyles({
            FONT: formatObj.FONT,
            SIZE: formatObj.SIZE,
            COLOR: formatObj.COLOR,
            BOLD: formatObj.BOLD
        }, true);
        var headerSelectors = lodash_1.default.map(table.header, getPartialClassNameSelector);
        var headerElements = lodash_1.default.join(headerSelectors, ',');
        var css = selector + " " + headerElements + " {"
            + format
            + '}';
        styles += css;
    });
    var headerStyles = exports.getGlobalRsdkTableHeaderStyles(formatHelper, formatObj);
    styles += headerStyles;
    return styles;
};
exports.getRsdkTableHeaderStyles = getRsdkTableHeaderStyles;
/**
 * Gets custom table body styles for RSDK table widgets using an array of selectors.
 */
var getRsdkTableBodyStyles = function (formatHelper, formatObj) {
    var styles = '';
    lodash_1.default.forEach(RSDK_TABLES_CSS_CLASSES, function (table) {
        var selector = table.selector;
        var format = formatHelper.getStyles({
            FONT: formatObj.FONT,
            SIZE: formatObj.SIZE,
            COLOR: formatObj.COLOR
        }, true);
        var bodySelectors = lodash_1.default.map(table.body, getPartialClassNameSelector);
        var bodyElements = lodash_1.default.join(bodySelectors, ',');
        var css = selector + " " + bodyElements + " {"
            + format
            + '}';
        styles += css;
    });
    var fontAndColor = exports.getGlobalRsdkTableBodyStyles(formatHelper, formatObj);
    styles += fontAndColor;
    return styles;
};
exports.getRsdkTableBodyStyles = getRsdkTableBodyStyles;
/**
 * Gets custom scale colors styles for RSDK table widgets using an array of selectors.
 */
var getRsdkTableScaleColorStyles = function (colors) {
    var styles = '';
    lodash_1.default.forEach(RSDK_TABLES_CSS_CLASSES, function (table) {
        var selector = table.selector;
        var scale = table.shouldApplyScaleColors;
        var unfavorableBg = getColorStyles(colors.unfavorable);
        var neutralBg = getColorStyles(colors.neutral);
        var favorableBg = getColorStyles(colors.favorable);
        if (scale) {
            // RSDK widgets should add those three classes to their UI component in order to apply scale colors
            var unfavorableCss = selector + " " + getPartialClassNameSelector('pr-unfavorable-color') + " " + unfavorableBg + " ";
            var neutralCss = selector + " " + getPartialClassNameSelector('pr-neutral-color') + " " + neutralBg + " ";
            var favorableCss = selector + " " + getPartialClassNameSelector('pr-favorable-color') + " " + favorableBg + " ";
            styles += unfavorableCss + neutralCss + favorableCss;
        }
    });
    return styles;
};
exports.getRsdkTableScaleColorStyles = getRsdkTableScaleColorStyles;
/**
 * Gets custom table body font, color for RSDK table widgets.
 */
var getGlobalRsdkTableBodyStyles = function (formatHelper, formatObj) {
    var styles = '';
    var fontFormat = formatHelper.getStyles({
        FONT: formatObj.FONT
    }, true, IMPORTANT);
    var colorFormat = formatHelper.getStyles({
        COLOR: formatObj.COLOR
    }, true);
    var fontCss = getPartialClassNameSelector('pr-rsdk-table-body-font') + " {" + fontFormat + "} ";
    var colorCss = getPartialClassNameSelector('pr-rsdk-table-body-color') + " {" + colorFormat + "} ";
    styles += fontCss + colorCss;
    return styles;
};
exports.getGlobalRsdkTableBodyStyles = getGlobalRsdkTableBodyStyles;
/**
 * Gets custom table header font, color and size for RSDK table widgets.
 */
var getGlobalRsdkTableHeaderStyles = function (formatHelper, formatObj) {
    var styles = '';
    var fontFormat = formatHelper.getStyles({
        FONT: formatObj.FONT
    }, true);
    var colorFormat = formatHelper.getStyles({
        COLOR: formatObj.COLOR
    }, true);
    var sizeFormat = formatHelper.getStyles({
        SIZE: formatObj.SIZE
    }, true);
    // For some reasons, the row will be broken into another page if having "header" in class name;
    var fontCss = getPartialClassNameSelector('pr-rsdk-table-row-font') + " {" + fontFormat + "}";
    var colorCss = getPartialClassNameSelector('pr-rsdk-table-row-color') + " {" + colorFormat + "}";
    var sizeCss = getPartialClassNameSelector('pr-rsdk-table-row-size') + " {" + sizeFormat + "}";
    styles += fontCss + colorCss + sizeCss;
    return styles;
};
exports.getGlobalRsdkTableHeaderStyles = getGlobalRsdkTableHeaderStyles;
var getColorStyles = function (color) {
    return "{background: " + color + "; color: " + getTextColor(color) + "}";
};
var MID_YIQ_VALUE = 128;
var isRgbColorDark = function (color) {
    if (color) {
        if (isValidRGBColor(color)) {
            return getColorYIQValue(color) < MID_YIQ_VALUE;
        }
        else if (isValidRGBColor(convertHexToRgb(color))) {
            return getColorYIQValue(convertHexToRgb(color)) < MID_YIQ_VALUE;
        }
    }
    return false;
};
var getColorYIQValue = function (color) {
    var rgb = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    if (Array.isArray(rgb) && rgb.length >= 4) {
        var r = typeof rgb[1] === 'number' ? rgb[1] : parseInt(rgb[1], undefined);
        var g = typeof rgb[2] === 'number' ? rgb[2] : parseInt(rgb[2], undefined);
        var b = typeof rgb[3] === 'number' ? rgb[3] : parseInt(rgb[3], undefined);
        // Uses YIQ color contrast algorithm - https://24ways.org/2010/calculating-color-contrast
        var yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq;
    }
    return 0;
};
var isValidRGBColor = function (color) {
    return !!(color && color.match(/^rgb/));
};
var convertHexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? "rgb(" + parseInt(result[1], 16) + ", " + parseInt(result[2], 16) + ", " + parseInt(result[3], 16) + ")" : hex;
};
var getTextColor = function (backgroundColor) {
    return isRgbColorDark(backgroundColor) ? 'white' : 'black';
};
